import config from "config";
import gsap from "gsap";
import { Container, Graphics } from "pixi.js";
import tools from "tools";
export default class Border extends Container {
  constructor(h, w) {
    super();
    this._headerSize = 0;
    this._thickness = config.borderThickness;
    this._h = h;
    this.build();
    this.progress(0);
    //hide all borderr
    this.visible = false;
  }
  build() {
    this.left = new Graphics();
    this.addChild(this.left);
    this.right = new Graphics();
    this.addChild(this.right);
    this.bottom = new Graphics();
    this.addChild(this.bottom);
  }
  set tint(val) {
    this._tint = val;
    this.left.tint = this._tint;
    this.right.tint = this._tint;
    this.bottom.tint = this._tint;
  }
  get tint() {
    return this._tint;
  }
  set thicknessScale(val) {
    this._thickness = config.borderThickness * val;
  }
  get thicknessScale() {
    return this._thickness;
  }
  progress(progressVal, timeVal) {
    let coef = 0;
    let timeSeg = 1 / 9;
    let time = 0;
    let val = progressVal > 9 ? 9 : progressVal;
    time = timeVal != null ? timeVal : timeSeg * 2;
    this.bottomTween && this.bottomTween.kill();
    this.leftTween && this.leftTween.kill();
    this.rightTween && this.rightTween.kill();
    if (val <= 3 && val > 0) {
      this.left.clear();
      this.right.clear();
      let LW = 4 - val;
      this.bottom.clear();
      this.bottom.lineStyle(this._thickness, 0xffffff, 1, 0.5);
      this.drawStrippyLine(this.bottom, {
        x: this._w * 0.5 - this._w / LW * 0.5,
        y: this._h
      }, {
        x: this._w * 0.5 + this._w / LW * 0.5,
        y: this._h
      });

      // try to use this.bottom, this.right, this.left as mask for 3 images bottom left right
    } else if (val > 3) {
      let LH = 7 - (10 - val);
      this.right.clear();
      this.right.lineStyle(this._thickness, 0xffffff, 1, 0.5);
      this.drawStrippyLine(this.right, {
        x: this._w - this._thickness * 0,
        y: this._h
      }, {
        x: this._w - this._thickness * 0,
        y: this._h - LH * this._h / 7
      });
      this.left.clear();
      this.left.lineStyle(this._thickness, 0xffffff, 1, 0.5);
      this.drawStrippyLine(this.left, {
        x: this._thickness * 0.1,
        y: this._h
      }, {
        x: this._thickness * 0.1,
        y: this._h - LH * this._h / 7
      });
    }
  }
  resize(w, h) {
    let headerStaticSize = 164;
    // this._headerSize = (h - config.container.height) / 2 + headerStaticSize * config.container.scale.y;

    // this.x = (w - config.view.x * config.container.scale.x) >> 1
    // this._h = h / 2 + (config.view.y * config.container.scale.y) / 2
    // this._w = config.view.x * config.container.scale.x;

    this._headerSize = headerStaticSize * config.container.scale.y;
    this._w = w;
    this._h = h;
    if (this.left) {
      this.left.clear();
      this.right.clear();
      this.bottom.clear();
    }
  }
  drawStrippyLine(g, p1, p2) {
    const dashLength = this._thickness * 0.75;
    const gapLength = this._thickness * 0.25;
    // Calculate distance and angle
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const angle = Math.atan2(dy, dx);
    let currentDistance = 0;
    while (currentDistance < distance) {
      // Start of the dash
      const startX = p1.x + Math.cos(angle) * currentDistance;
      const startY = p1.y + Math.sin(angle) * currentDistance;
      currentDistance += dashLength;
      if (currentDistance > distance) currentDistance = distance;
      // End of the dash
      const endX = p1.x + Math.cos(angle) * currentDistance;
      const endY = p1.y + Math.sin(angle) * currentDistance;
      g.moveTo(startX, startY);
      g.lineTo(endX, endY);

      // Add the gap
      currentDistance += gapLength;
    }
  }
  clearAll() {
    this.left.clear();
    this.right.clear();
    this.bottom.clear();
  }
  update() {}
}
